import StoreState from 'store/state'
import { createSelector } from 'reselect'
import { initialState } from './state'

export const authSelector = (state: StoreState) => state.auth || initialState()
export const facebookLoginStatusSelector = createSelector(authSelector, auth => auth.facebookLoginStatus)
export const authErrorSelector = createSelector(authSelector, auth => auth.error)
export const expiredTokensSelector = createSelector(authSelector, auth => auth.tokens.refreshRequired || {})
